import { useState } from 'react';
import PropTypes from 'prop-types';

// components
import SmallAvatar from './SmallAvatar';
import BigAvatar from './BigAvatar';
import PortraitAvatar from './PortraitAvatar';

// contants
import { AVATAR_SIZE } from '../../constants';

import { AVATAR_URL } from 'constants/api';

function ImageProfile(props) {
  const [avatarDiv, setAvatarDiv] = useState(null);
  const [avatarClass, setAvatarClass] = useState('');
  const { mode } = props;

  const handleImageOnLoad = () => {
    setAvatarClass('popavatar');
  };

  const onAvatarError = () => {
    const { username } = props;
    const initial = username ? username.charAt(0) : null;

    setAvatarDiv(initial);
  };

  return (
    <>
      {mode === AVATAR_SIZE.BIG && (
        <BigAvatar
          {...props}
          state={{ avatarDiv, avatarClass }}
          onAvatarError={onAvatarError}
          handleImageOnLoad={handleImageOnLoad}
        />
      )}
      {mode === AVATAR_SIZE.SMALL && (
        <SmallAvatar
          {...props}
          state={{ avatarDiv, avatarClass }}
          onAvatarError={onAvatarError}
          handleImageOnLoad={handleImageOnLoad}
        />
      )}
      {mode === AVATAR_SIZE.PORTRAIT && <PortraitAvatar {...props} />}
    </>
  );
}

ImageProfile.propTypes = {
  mode: PropTypes.oneOf([
    AVATAR_SIZE.BIG,
    AVATAR_SIZE.SMALL,
    AVATAR_SIZE.PORTRAIT,
  ]),
  avatar_override: PropTypes.string,
  custom: PropTypes.string,
  avatar: PropTypes.string,
  temp_avatar: PropTypes.string,
  hide_loader: PropTypes.bool,
  overlayClassName: PropTypes.string,
  username: PropTypes.string,
  avatarURL: PropTypes.string,
};

ImageProfile.defaultProps = {
  mode: AVATAR_SIZE.SMALL,
  avatar_override: '',
  custom: '',
  avatar: '',
  temp_avatar: '',
  hide_loader: true,
  overlayClassName: '',
  username: '',
  avatarURL: AVATAR_URL,
};

export default ImageProfile;
